import { useState } from 'react';
import { Copy, Check, Share2 } from 'lucide-react';

interface InviteLinkProps {
  roomId: string;
}

export function InviteLink({ roomId }: InviteLinkProps) {
  const [copied, setCopied] = useState(false);
  const inviteUrl = `${window.location.origin}/join/${roomId}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(inviteUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2400);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = inviteUrl;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      setCopied(true);
      setTimeout(() => setCopied(false), 2400);
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between text-xs font-semibold uppercase tracking-wider text-cinema-300">
        <span className="flex items-center gap-1.5">
          <Share2 className="w-3.5 h-3.5 text-lamp" />
          <span>Invite Friends</span>
        </span>
        {copied && <span className="text-reel-emerald text-[11px] font-medium">Link Copied!</span>}
      </div>

      <div className="flex items-center gap-2 p-1.5 rounded-md bg-cinema-950 border border-cinema-700/80">
        <div className="flex-1 min-w-0 px-2 text-xs text-cinema-300 truncate select-all">
          {inviteUrl}
        </div>
        <button
          onClick={handleCopy}
          className="flex-shrink-0 p-1.5 rounded bg-cinema-800 hover:bg-cinema-750 text-cinema-300 hover:text-cinema-100 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lamp"
          title="Copy Invitation Link"
          aria-label="Copy invitation link"
        >
          {copied ? (
            <Check className="w-3.5 h-3.5 text-reel-emerald" />
          ) : (
            <Copy className="w-3.5 h-3.5" />
          )}
        </button>
      </div>
    </div>
  );
}
